import { SparkDivider } from "@motley/design"
import Hero from "./Hero"
import Pain from "./Pain"
import Staircase from "./staircase/Staircase"
import Craftsmanship from "./Craftsmanship"
import Terms from "./Terms"
import Cta from "./Cta"
import DemoVideo from "@/content/homepage/DemoVideo"

export default function Homepage() {
  return (
    <>
      <Hero />
      <SparkDivider className="mx-auto max-w-140" />
      <Pain />
      <DemoVideo />
      <Staircase />
      <Craftsmanship />
      <Terms />
      <Cta />
    </>
  )
}
